export default function printBuildInfo () {
  console.log('<----BUILD INFO---->');
  console.log(`env: ${env || 'local'}`);
  FEbuild && console.log(`FEbuild: ${FEbuild}`);
  commitHash && console.log(`commitHash: ${commitHash}`);
  console.log(`buildTimestamp: ${CIbuildTimeStamp}`);
  console.log('<------------------>');
}
